import config from 'config';

export const getLocalStorageObject = <TValue>(key: string): TValue | undefined => {
  try {
    const itemInStorage = localStorage.getItem(key);
    return itemInStorage ? (JSON.parse(itemInStorage) as TValue) : undefined;
  } catch {
    return undefined;
  }
};

export const setLocalStorageObject = <TValue>(key: string, value: TValue) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

const createScopedKey = (keyPrefix: string) =>
  `${keyPrefix}__${config.isProduction ? 'production' : 'staging'}`;

export function getScopedLocalStorageValue(accountId: number, keyPrefix: string) {
  const key = createScopedKey(keyPrefix);
  const values = getLocalStorageObject<Array<number>>(key);
  return Array.isArray(values) ? values.includes(accountId) : false;
}

export function setScopedLocalStorageValue(accountId: number, keyPrefix: string, enabled: boolean) {
  const key = createScopedKey(keyPrefix);
  let existingValues = getLocalStorageObject<Array<number>>(key);
  if (!Array.isArray(existingValues)) {
    existingValues = [];
  } else {
    existingValues = existingValues.filter(id => id !== accountId);
  }

  if (enabled) {
    existingValues.push(accountId);
  }

  setLocalStorageObject(key, existingValues);
}
